<template>
  <div class="download-panel" v-if="isUserLeadViewer && showPanel">
    <button class="btn-close" @click="showPanel = false">
      <span class="material-icons">close</span>
    </button>
    {{ $t("DownloadChromePluginPanel.Message") }}
    <b-button type="is-primary" size="is-small" class="btn-open" @click="openPluginPage">
      <div class="button-inner">
        {{ $t("DownloadChromePluginPanel.Button") }}
      </div>
    </b-button>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { UserData } from "@/models/UserData";
import ConfigService from "@/services/ConfigService";
import HelperService from "@/services/HelperService";

const namespace = "mainModule";

@Component({
  components: {},
})
export default class DownloadChromePluginPanel extends Vue {

  //#region Vuex getters and actions

  @Getter("userData", { namespace }) userData!: UserData;

  //#endregion Vuex getters and actions


  showPanel = false;

  mounted() {
    this.showPanel = !document.cookie.split('; ').find(row => row.startsWith('extension_downloaded'));
  }

  get isUserLeadViewer(): boolean {
    return HelperService.isUserInRole(this.userData, ConfigService.leadViewerUserRole);
  }

  openPluginPage() {
    window.open("https://chrome.google.com/webstore/detail/fixdigital-plugin-for-gma/pblpdhdohbbgoodcdnjiiinnhphhdlcn", '_blank');
  }
}
</script>

<style lang="scss" scoped>
.download-panel {
  background: #fff;
  padding: 1rem;
  position: relative;

  .btn-close {
    background: transparent;
    border: 0;
    cursor: pointer;
    left: auto;
    position: absolute;
    right: .5rem;
    top: .5rem;

    &:hover {
      color: #999;
    }
  }

  .btn-open {
    margin: 0 1rem;

    @media (max-width: 991px) {
      margin: 0;
    }
  }
}

html[dir="rtl"] {
  .download-panel {
    .btn-close {
      left: .5rem;
      right: auto;
    }
  }
}
</style>
